var _text, _g, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoInline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "20.6 13.3 404.9 64.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#A8E846"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#00C853"
    }
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 72,
    fontFamily: "Montserrat, Arial, sans-serif",
    fontWeight: 800,
    fontSize: 68,
    fill: "#F7F9FB",
    letterSpacing: -2
  }, "Descont")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(348, 49) scale(0.18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -38 -115 A 120 120 0 1 0 38 -115",
    fill: "none",
    stroke: "url(#grad)",
    strokeWidth: 28,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -14,
    y: -170,
    width: 28,
    height: 165,
    rx: 14,
    fill: "url(#grad)"
  }))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 378,
    y: 72,
    fontFamily: "Montserrat, Arial, sans-serif",
    fontWeight: 800,
    fontSize: 68,
    fill: "#00C853",
    letterSpacing: -2
  }, "n")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInline);
export default __webpack_public_path__ + "static/media/logo_inline.d89374a335c119c37595b98b8aa4c2cd.svg";
export { ForwardRef as ReactComponent };